import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Icon from 'components/DesignSystem/Icon';
import Slider from 'components/DesignSystem/Slider';
import { Image } from 'helper/products/synopticCharts';
import {
  selectImageIndex,
  selectImages,
  selectImagesAreLoading,
  setImageIndex,
} from 'redux/reducers/synopticChartsReducer';
import { cssVar } from 'constants/theme';
import imageDateLabel from './imageDateLabel';

export default function ImageNav() {
  const dispatch = useDispatch();
  const images: Image[] | undefined = useSelector(selectImages);
  const isLoading: boolean = useSelector(selectImagesAreLoading);
  const selectedIndex: number = useSelector(selectImageIndex);

  const list = images ?? [];
  const available = list.length > 0;
  const maxIndex = available ? list.length - 1 : 0;
  const disabled = isLoading || !available;

  const goTo = (index: number) => {
    dispatch(setImageIndex(Math.max(0, Math.min(index, maxIndex))));
  };

  return (
    <div className={`sc-mobile-image-nav${disabled ? ' is-disabled' : ''}`}>
      <div className="sc-mobile-image-nav-label">
        {imageDateLabel(list[selectedIndex]?.date)}
      </div>

      <div className="sc-mobile-image-nav-controls">
        <button
          type="button"
          aria-label="Primeira imagem"
          className="sc-mobile-image-nav-button"
          disabled={disabled}
          onClick={() => goTo(0)}
        >
          <Icon iconType="double_left_arrow" color={cssVar('text-accent')} size="small" />
        </button>
        <button
          type="button"
          aria-label="Imagem anterior"
          className="sc-mobile-image-nav-button"
          disabled={disabled}
          onClick={() => goTo(selectedIndex - 1)}
        >
          <Icon iconType="left_arrow" color={cssVar('text-accent')} size="small" />
        </button>

        <Slider
          className="sc-mobile-image-nav-slider"
          min={0}
          max={maxIndex}
          value={selectedIndex}
          setValue={goTo}
        />

        <button
          type="button"
          aria-label="Próxima imagem"
          className="sc-mobile-image-nav-button"
          disabled={disabled}
          onClick={() => goTo(selectedIndex + 1)}
        >
          <Icon iconType="right_arrow" color={cssVar('text-accent')} size="small" />
        </button>
        <button
          type="button"
          aria-label="Última imagem"
          className="sc-mobile-image-nav-button"
          disabled={disabled}
          onClick={() => goTo(maxIndex)}
        >
          <Icon iconType="double_right_arrow" color={cssVar('text-accent')} size="small" />
        </button>
      </div>

      {available && (
        <div className="sc-mobile-image-nav-caption">
          {`Imagem ${selectedIndex + 1} de ${list.length} · toque para ampliar`}
        </div>
      )}
    </div>
  );
}
